import { useAuth0 } from '@auth0/auth0-react';
import { AuthEvent } from 'enums/auth';
import { useCallback } from 'react';
import { useAuthStore } from 'stores/use-auth-store';

// zustand does not have access to Auth0 context, so we'll use this hook to clear both Auth0 and our own auth state if needed
const useLogout = () => {
  const { logout: logoutAuth0 } = useAuth0();

  const handleLogout = useCallback(
    async (config?: { reason: AuthEvent }) => {
      await useAuthStore.getState().logout({
        reason: config?.reason || 'logout',
      });
      await logoutAuth0({
        logoutParams: {
          returnTo: window.location.origin,
        },
      });
    },
    [logoutAuth0]
  );

  return {
    logout: handleLogout,
  };
};

export default useLogout;
